module.exports = "<div id=\"map\"></div>\n"